import { cn } from "@/utils/cn";
import { PlaygroundSidebar } from "./playground-sidebar";
import { PlaygroundMain } from "./playground-main";
import { HistorySidebarAccessibility } from "./history-sidebar-accessibility";
import { useConversationScope } from "@/hooks/useConversationScope";
import { usePlaygroundRouting } from "../routing/playground-routing";
import { PlaygroundPresentationProvider, usePlaygroundPresentation } from "./playground-presentation";
import { PlaygroundRunSettingsPanel } from "./playground-run-settings-panel";

const PlaygroundLayout = ({
  singleRenderedChildren = false,
}: {
  singleRenderedChildren: boolean;
}) => {
  const { identity } = useConversationScope();
  const { id, pathname, routeNamespace } = usePlaygroundRouting();
  const modern = routeNamespace === "playground" && pathname?.split("/")[1] === "playground";
  const content = (
    <HistorySidebarAccessibility scopeKey={JSON.stringify([identity, id])}>
      <PlaygroundLayoutContent singleRenderedChildren={singleRenderedChildren} />
    </HistorySidebarAccessibility>
  );
  return modern ? <PlaygroundPresentationProvider scopeKey={JSON.stringify([identity, id])}>{content}</PlaygroundPresentationProvider> : content;
};

const PlaygroundLayoutContent = ({ singleRenderedChildren }: { singleRenderedChildren: boolean }) => {
  const { modern } = usePlaygroundPresentation();
  return (
    <div
      data-playground-layout={modern ? "app-shell" : "legacy"}
      className={cn("flex relative w-full overflow-hidden", modern ? "h-full min-h-0 bg-background" : {
          "min-h-screen max-h-screen": singleRenderedChildren,
          "h-full": !singleRenderedChildren,
          "p-2 md:p-8": !singleRenderedChildren,
      })}
    >
      {modern ? <><PlaygroundMain /><PlaygroundSidebar /><PlaygroundRunSettingsPanel /></> : <><PlaygroundSidebar /><PlaygroundMain /></>}
    </div>
  );
};
export { PlaygroundLayout };
